export enum App {
    Admin = 1,
    Participants = 2,
}